/* eslint-env jest */
import { computeSummaryTotals } from './summaryTotals';

// The senior appointment checkout summary must show an itemized Discount line
// when a coupon is applied, and the numbers have to reconcile
// (subtotal - discount + tax = total). Regression coverage for the
// coupon-on-sittings feature.
describe('computeSummaryTotals', () => {
  it('reads a real cart with no coupon (no discount)', () => {
    const cart = {
      subtotalWithoutCoupon: 29.95, couponValue: 0, apiTax: 0, apiTotal: 29.95,
    };
    expect(computeSummaryTotals(cart)).toEqual({
      subtotal: 29.95, discount: 0, tax: 0, total: 29.95,
    });
  });

  it('shows the pre-coupon subtotal and the discount when a coupon is applied', () => {
    // $29.95 session, $5 off, no tax -> total $24.95
    const cart = {
      subtotalWithoutCoupon: 29.95, subtotal: 24.95, couponValue: 5, apiTax: 0, apiTotal: 24.95,
    };
    const {
      subtotal, discount, tax, total,
    } = computeSummaryTotals(cart);
    expect(subtotal).toBe(29.95); // full price, not the post-coupon subtotal
    expect(discount).toBe(5);
    expect(tax).toBe(0);
    expect(total).toBe(24.95);
    expect(Number((subtotal - discount + tax).toFixed(2))).toBe(total); // reconciles
  });

  it('handles a coupon that zeroes the total (apiTotal 0 is respected, not treated as falsy)', () => {
    const cart = {
      subtotalWithoutCoupon: 29.95, subtotal: 0, couponValue: 29.95, apiTax: 0, apiTotal: 0,
    };
    expect(computeSummaryTotals(cart)).toEqual({
      subtotal: 29.95, discount: 29.95, tax: 0, total: 0,
    });
  });

  it('includes tax in the total', () => {
    const cart = {
      subtotalWithoutCoupon: 100, couponValue: 10, apiTax: 7, apiTotal: 97,
    };
    expect(computeSummaryTotals(cart)).toEqual({
      subtotal: 100, discount: 10, tax: 7, total: 97,
    });
  });

  it('falls back to summing demo items when there is no cart', () => {
    const items = [{ price: 29.95 }, { price: 10 }];
    expect(computeSummaryTotals(null, items)).toEqual({
      subtotal: 39.95, discount: 0, tax: 0, total: 39.95,
    });
  });

  it('falls back to cart.subtotal when subtotalWithoutCoupon is absent', () => {
    const cart = { subtotal: 50, apiTax: 0, apiTotal: 50 };
    expect(computeSummaryTotals(cart)).toEqual({
      subtotal: 50, discount: 0, tax: 0, total: 50,
    });
  });
});
